export default "__VITE_ASSET___X5G5kXj__"